import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { PermissionType } from '../../enums/enums';
import { BaseService } from '../services/base.service';
import { DashboardInformationService } from '../services/dashboard-information.service';

import jwt_decode from 'jwt-decode';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromApp from '../../store/app.reducer';
import * as TokenInformationActions from 'app/tokeninformation/store/token-information.actions';
import * as ConfigurationActions from 'app/configurations/store/configurations.actions';
import * as ScreenInformationActions from 'app/screeninformation/store/screeninformation.actions';
import { LoggedInUserInformation } from 'app/storeInformation/loogedInUserInformation/store/loggedinuser-information.model';
import { ScreenInformation } from 'app/screeninformation/store/screeninformation.model';
import { DashboardInformation } from 'app/dashboardInformation/store/dashboard-information.model';
import * as PermissionActions from '../../permissions/store/permission.actions';
import * as DashboardInformationActions from '../../dashboardInformation/store/dashboard-information.actions';
import * as LoggedInUserInformationActions from '../../storeInformation/loogedInUserInformation/store/loggedinuser-information.actions';
import { localStorageInformationId, systemConstants } from '../modals/common';
import { TokenInformation } from 'app/tokeninformation/store/token-information.model';
import { Configurations } from 'app/configurations/store/configurations.model';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService,
    private store: Store<fromApp.AppState>,
    private router: Router,
    private dashboardInformationService: DashboardInformationService,
    private baseService: BaseService,
    private dashboardService: DashboardInformationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const taskId = route.data.taskId;
    localStorage.setItem('url', state.url);

    return this.checkPermissionForPage(taskId, route).pipe(
      tap(allowed => {
        console.log('canActivate responded');
        if (!allowed) {
          // navigate to dashboard if not permitted
          var dashBoardPageUrl = '/Pages/Baseframework/MyDashBoard';
          window.location.href = dashBoardPageUrl;
        } else {
          const UserDetail = this.authService.getUserDetail();
          const name = this.getScreenName(route.data.screenId);
          document.getElementsByTagName('title')[0].innerHTML = name;
          this.baseService.AddActivityLog(UserDetail.OrgId, UserDetail.UserId, route.data.screenId, 'View', 0, '', 2023);
        }
      })
    );
  }

  checkPermissionForPage(taskId, route: ActivatedRouteSnapshot): Observable<boolean> {
    let allowCreate = true;
    let allowRead = true;

    return this.authService.isTaskPermissionAllowed(taskId, PermissionType.Read).pipe(
      map(res => {
        allowRead = res;
        console.log('checkPermissionForPage responded');
        // const routeUrl = route.pathFromRoot
        //   .map(v => v.url.map(segment => segment.toString()).join('/'))
        //   .join('/');
        // const lastPart = routeUrl.split('/');
        // if (lastPart[lastPart.length - 1].toString().toUpperCase() == 'CREATE') {
        //   allowCreate = this.authService.isTaskPermissionAllowed(taskId, PermissionType.Create);
        // }

        if (!allowRead || !allowCreate) {
          return false;
        } else {
          return true;
        }
      })
    );

    // var permission = new Subject<boolean>();
    // this.authService.isTaskPermissionAllowed(taskId, PermissionType.Update)
    //   .subscribe(res => {
    //     allowRead = res;
    //     // const routeUrl = route.pathFromRoot
    //     //   .map(v => v.url.map(segment => segment.toString()).join('/'))
    //     //   .join('/');
    //     // const lastPart = routeUrl.split('/');
    //     // if (lastPart[lastPart.length - 1].toString().toUpperCase() == 'CREATE') {
    //     //   allowCreate = this.authService.isTaskPermissionAllowed(taskId, PermissionType.Create);
    //     // }

    //     if (!allowRead || !allowCreate) {
    //       permission.next(false);
    //     } else {
    //       permission.next(true);
    //     }
    //   });
    // return permission.asObservable();
  }

  getScreenName(ScreenId) {
    const ScreenList = this.authService.getScreenList() || [];
    if (ScreenList.length > 0) {
      const screen = ScreenList.find(e => e.ScreenId == ScreenId);
      if (screen != undefined) {
        localStorage.setItem('screenId', ScreenId);
        return screen.ScreenTitle;
      }
    }
    return '';
  }

  getPermissionData() {
    const tokenpromis = this.dashboardInformationService.generateTokenP();
    tokenpromis.then((data) => {
      const result = data;
      var info = jwt_decode(result.data);
      const tokenInformation: TokenInformation = {
        userId: info['userId'],
        storeLocationId: info['storeLocationId'],
        orgId: info['orgId']
      };
      this.store.dispatch(new TokenInformationActions.AddTokenInformation(tokenInformation));
      this.baseService.setLocalData(localStorageInformationId.userTokenInfo, tokenInformation);

      const promise = this.baseService.callAPIWithPromis('/baseframework/LoggedInUser', {
        "StoreLocationId": parseInt(info['storeLocationId']),
        "UserId": parseInt(tokenInformation.userId),
        "orgid": info['orgId'],
        "Token": systemConstants.bodyToken
      });
      promise.then((data) => {
        if (data['data'] != '') {
          var res_item = JSON.parse(this.baseService.Decrypt(data['data']));
          let loggedInUserInformation: LoggedInUserInformation;
          loggedInUserInformation = res_item;
          this.baseService.setLocalData(localStorageInformationId.loggedInUserInformation, loggedInUserInformation);
          this.store.dispatch(new LoggedInUserInformationActions.AddLoggedInUserInformation(loggedInUserInformation));
        }
      }, (error) => {
        console.log("Promise rejected with " + JSON.stringify(error));
      });
      const configpromise = this.baseService.callAPIWithPromis('/CommonDll/GetConfigurationItemList', null);
      configpromise.then((data) => {
        if (data['data'] != '') {
          var res_item = this.baseService.Decrypt(data['data']);
          let configuationValues: Configurations;
          configuationValues = JSON.parse(res_item);
          this.store.dispatch(new ConfigurationActions.AddConfiguration(configuationValues));
        }
      }, (error) => {
        console.log("Promise rejected with " + JSON.stringify(error));
      });
      const screenpromise = this.baseService.callAPIWithPromis('/CommonDll/GetAllScreen', null);
      screenpromise.then((data) => {
        if (data['data'] != '') {

          var res_item = this.baseService.Decrypt(data['data']);
          let screenValues: ScreenInformation[];
          screenValues = res_item;
          this.store.dispatch(new ScreenInformationActions.AddScreenInformation(screenValues));
        }
      }, (error) => {
        console.log("Promise rejected with " + JSON.stringify(error));
      });
      const dashboardinfopromise = this.baseService.callAPIWithPromis('/dashboardInformation/getDashboardInformation', null);
      dashboardinfopromise.then((data) => {
        if (data['data'] != '') {
          // var res_item = this.baseService.Decrypt(data['data']);
          const dashboardInformation = JSON.parse(data['data']);
          if (dashboardInformation.IsUserLoggedIn) {
            const menuItemsDynamic = dashboardInformation.HorizontalUserMenuList ?
              JSON.parse(dashboardInformation.HorizontalUserMenuList) : '';

            this.baseService.setLocalData('menuItemsDynamic', menuItemsDynamic);
            const permissions = dashboardInformation.PermissionListData ?
              dashboardInformation.PermissionListData : [];
            this.baseService.setLocalData('permissions', permissions);
            this.baseService.setLocalData('dashboardInformation', dashboardInformation);
            this.store.dispatch(new PermissionActions.AddPermission(permissions));
            const dashboardInformation1: DashboardInformation = new DashboardInformation(dashboardInformation.WelcomeText, dashboardInformation.DashboardUsername, dashboardInformation.UserProfileInformation);
            this.store.dispatch(new DashboardInformationActions.AddDashboardInformation(dashboardInformation1));
            this.baseService.setLocalData(localStorageInformationId.loggedInUserInformation, dashboardInformation.UserProfileInformation);
            this.store.dispatch(new LoggedInUserInformationActions.AddLoggedInUserInformation(dashboardInformation.UserProfileInformation));
          } else {
            var loginPageUrl = 'Pages/Baseframework/Security/Login';
            window.location.href = loginPageUrl;
          }
        }
      }, (error) => {
        console.log("Promise rejected with " + JSON.stringify(error));
      });

    }, (error) => {
      console.log("Promise rejected with " + JSON.stringify(error));
    });
  }
}


// import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
// import { Injectable } from '@angular/core';
// import { AuthService } from './auth.service';
// import { PermissionType } from '../../enums/enums';
// @Injectable()
// export class AuthGuard implements CanActivate {

//   constructor(private authService: AuthService, private router: Router) { }

//   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
//     const taskId = route.data.taskId;
//     // let isAuth = this.authService.isAuthenticated();
//     let isPermitted = this.checkPermissionForPage(taskId, route);
//     if (!isPermitted) {
//       // this.router.navigate(['/pages/login']);
//       var dashBoardPageUrl = '/Pages/Baseframework/MyDashBoard';
//       window.location.href = dashBoardPageUrl;
//     } else {
//       return true;
//     }
//   }

//   checkPermissionForPage(taskId, route: ActivatedRouteSnapshot) {
//     let allowCreate = true;
//     let allowRead = true;

//     allowRead = this.authService.isTaskPermissionAllowed(taskId, PermissionType.Read);

//     // // manually set to false now just to test the redirection scenario, to be removed afterwards
//     // allowRead = false;

//     const routeUrl = route.pathFromRoot
//       .map(v => v.url.map(segment => segment.toString()).join('/'))
//       .join('/');
//     const lastPart = routeUrl.split('/');
//     if (lastPart[lastPart.length - 1].toString().toUpperCase() == 'CREATE') {
//       allowCreate = this.authService.isTaskPermissionAllowed(taskId, PermissionType.Create);
//     }

//     if (!allowRead || !allowCreate) {
//       // var dashBoardPageUrl = '/Pages/Baseframework/MyDashBoard';
//       // window.location.href = dashBoardPageUrl;
//       return false;
//     } else {
//       return true;
//     }

//     // if (!AllowRead || !AllowCreate) {
//     //   if (Request.GetDisplayUrl().IndexOf("MyDashBoard") != -1) {
//     //     context.Result = new RedirectResult("/Pages/Baseframework/Security/Login", false);
//     //   }
//     //   else {
//     //     context.Result = new RedirectResult("/Pages/Baseframework/MyDashBoard", false);
//     //   }
//     // }
//   }
// }
